import { Component } from '@angular/core';

@Component({
  selector: 'tlp-subscription-confirmation',
  templateUrl: './subscription-confirmation.component.html',
  styleUrls: ['./subscription-confirmation.component.css']
})
export class SubscriptionConfirmationComponent {

}
